import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-39217277"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "abusolute-center bg-white shadow-lg w-full sm:w-max rounded-lg" };
const _hoisted_2 = {
    class: "py-8 px-5 sm:px-12",
    id: "app"
};
const _hoisted_3 = { class: "grid grid-cols-1 gap-5" };
const _hoisted_4 = { class: "block" };
const _hoisted_5 = { class: "text-gray-700" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_7 = { class: "block" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-gray-700" }, "事業部", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_10 = { class: "block" };
const _hoisted_11 = { class: "text-gray-700" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_13 = { class: "" };
const _hoisted_14 = { class: "block" };
const _hoisted_15 = { class: "text-gray-700" };
const _hoisted_16 = { class: "" };
const _hoisted_17 = { class: "block" };
const _hoisted_18 = { class: "text-gray-700" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_20 = { class: "block" };
const _hoisted_21 = { class: "text-gray-700" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_23 = { class: "block" };
const _hoisted_24 = { class: "text-gray-700" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "form-required" }, "必須", -1));
const _hoisted_26 = { id: "quill" };
const _hoisted_27 = { class: "flex justify-center mt-8" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_ErrMsgCard = _resolveComponent("ErrMsgCard");
    const _component_quill_Editor = _resolveComponent("quill-Editor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Title, {
                msg: "テンプレート更新",
                submsg: "Template Update"
            }),
            _createVNode(_component_ErrMsgCard, {
                errMsgs: $data.errMsgs,
                process: "テンプレート更新"
            }, null, 8, ["errMsgs"]),
            _createElementVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.templateUpdate && _ctx.templateUpdate(...args)), ["prevent"])),
                class: "text-gray-700"
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString($data.templateId.key), 1),
                        _hoisted_6,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "0123",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.templateId.value) = $event)),
                            class: "w-1/2",
                            readonly: ""
                        }, null, 512), [
                            [_vModelText, $data.templateId.value]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_7, [
                        _hoisted_8,
                        _hoisted_9,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.division.setValue1) = $event)),
                            class: "w-1/2",
                            readonly: ""
                        }, null, 512), [
                            [_vModelText, $data.division.setValue1]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString($data.releaseTime.key), 1),
                        _hoisted_12,
                        _createElementVNode("p", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                                type: "time",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($data.releaseTime.value) = $event)),
                                class: "w-1/2"
                            }, null, 512), [
                                [_vModelText, $data.releaseTime.value]
                            ])
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString($data.crmGetFlg.key), 1),
                        _createElementVNode("p", _hoisted_16, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.crmGetFlg.value) = $event)),
                                class: "form-checkbox text-indigo-600 h-6 w-6"
                            }, null, 512), [
                                [_vModelCheckbox, $data.crmGetFlg.value]
                            ])
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString($data.title.key), 1),
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "タイトル",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.title.value) = $event)),
                            maxlength: "50",
                            class: "w-full",
                            id: "title"
                        }, null, 512), [
                            [_vModelText, $data.title.value]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString($data.sub.key), 1),
                        _hoisted_22,
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "プッシュ通知内容",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.sub.value) = $event)),
                            class: "w-full"
                        }, null, 512), [
                            [_vModelText, $data.sub.value]
                        ])
                    ]),
                    _createElementVNode("label", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString($data.body.key), 1),
                        _hoisted_25
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_quill_Editor, {
                            toolbar: $data.toolbar,
                            modules: $data.modules,
                            ref: "myEditor",
                            theme: "snow"
                        }, null, 8, ["toolbar", "modules"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$router.go(-1))),
                            name: "buck-button",
                            class: "button btn-gray w-full mr-5 md:mr-10"
                        }, " 戻る "),
                        _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => ($options.update && $options.update(...args))),
                            name: "button",
                            class: "button btn-red w-full"
                        }, " 更新 ")
                    ])
                ])
            ], 32)
        ])
    ]));
}
